<template>
  <div class="photo-upload">
    <ul class="clearfix">
      <li v-show="!url">
        <label>
          <span></span>
          <input type="file" name="flieupload" ref="flieupload" @change="uploadImage($event)">
        </label>
      </li>
      <li v-if="url">
        <img v-bind:src="url" alt>
        <i class="close-icon" @click="resetCardImage(2)"></i>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'upload-simple',
  props: {
    url: {
      type: String,
      required: false,
      default: ''
    },
    // 允许上传的文件后缀,中间以逗号隔开
    type: {
      type: String,
      required: false,
      default: 'jpg,jpeg,png'
    },
    /**
     * 允许上传的文件大小
     */
    fileSize: {
      type: String,
      default: '2m',
      validator: function(value) {
        return /^([\d]{1,8}([mkbMKB]{1}))$/.test(value)
      }
    }
  },
  model: {
    prop: 'url',
    event: 'change'
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    resetCardImage() {
      this.$emit('change', '')
      this.uploadShow = true
    },
    getFileExtension(fileName) {
      let pos = fileName.lastIndexOf('.')
      if (pos >= 0) {
        return fileName.substring(pos + 1)
      } else {
        return ''
      }
    },
    uploadImage(event) {
      var _this = this
      var files = event.target.files
      var choosedFilesCount = files.length
      if (choosedFilesCount < 1) return
      if (choosedFilesCount > 1) {
        this.$dialog.toast({
          mes: '最多只能选择1个文件',
          timeout: 1500,
          icon: 'error'
        })
        return
      }
      let file = files[0]
      // 检验后缀名
      if (this.type) {
        var name = this.getFileExtension(file.name) + ','
        var type = this.type + ','
        if (type.indexOf(name) < 0) {
          this.$dialog.toast({
            mes: '仅能上传' + this.type + '的格式文件',
            timeout: 1500,
            icon: 'error'
          })
          return
        }
      }

      var formData = new FormData()
      formData.append('file', file, file.name)

      this.$postImg('/api/Common/UploadFile', formData).then(result => {
        this.$emit('change', result)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.photo-upload {
  li {
    float: left;
    width: 120 / @rem-size;
    height: 120 / @rem-size;
    position: relative;
    margin-right: 20 / @rem-size;
    margin-top: 15 / @rem-size;

    input[type='file'] {
      display: none;
    }

    .close-icon {
      position: absolute;
      width: 40 / @rem-size;
      height: 40 / @rem-size;
      background: #05d095;
      border-radius: 1000px;
      right: -10 / @rem-size;
      top: -10 / @rem-size;

      &:active {
        background: #05d095 - 10%;
      }

      &:after {
        content: '';
        display: block;
        width: 41 / @rem-size;
        height: 41 / @rem-size;
        background: url('../assets/images/delete-img.png') center center no-repeat;
        background-size: cover;
      }
    }

    img {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 8 / @rem-size;
    }

    span {
      width: 100%;
      height: 100%;
      border-radius: 8 / @rem-size;
      display: block;
      position: relative;
      background: #f7f7f7;

      &:after {
        content: '';
        position: absolute;
        width: 120 / @rem-size;
        height: 120 / @rem-size;
        background: url('../assets/images/add-img.png') center center no-repeat;
        background-size: cover;
        left: 50%;
        top: 50%;
        margin-top: -60 / @rem-size;
        margin-left: -60 / @rem-size;
      }

      &:active {
        background: #f7f7f7 - 10%;
      }
    }
  }
}
</style>
